$(document).ready(function() {
    $(document).on('click',".toggle-btn",function() {
        //$(".header-hide-layer").addClass("menu-show"), $(".left-nav-fix").addClass("menu-show"), $("body").addClass("overflow-hidden")
    }), 
    $(".close-nav").click(function() {
        // $(".header-hide-layer").removeClass("menu-show"), $(".left-nav-fix").removeClass("menu-show"), $("body").removeClass("overflow-hidden")
    }), $(".menu-hide").click(function() {
        $(this).removeClass("menu-show"), $(".left-nav-fix").removeClass("menu-show"), $(".search-box").removeClass("menu-show"), $("body").removeClass("overflow-hidden")
    }), $(".search-icon").click(function() {
        $(".header-hide-layer").addClass("menu-show"), $(".search-box").addClass("menu-show"), $("body").addClass("overflow-hidden")
    }), $(".close-icon-s").click(function() {
        $(".search-box").removeClass("menu-show"), $(".header-hide-layer").removeClass("menu-show"), $(".search-result-show").removeClass("show"), $(".most-popular").removeClass("hide"), $(".clear-input").removeClass("show"), $("body").removeClass("overflow-hidden")
    }), $(".search-input").on("keyup", function() {
        var ID = this.id;
        this.value.length > 1 ? ($(".search-result-show").addClass("show"), $(".most-popular").addClass("hide"), $(".clear-input").addClass("show")) : ($(".search-result-show").removeClass("show"), $(".most-popular").removeClass("hide"), $(".clear-input").removeClass("show"))
    }), $(function() {
        $(".clear-input").click(function() {
            $(".search-result-show").removeClass("show"), $(".most-popular").removeClass("hide"), $(".clear-input").removeClass("show")
        })
    }), $(".list-sidbar > .arrrow-icon").on("click", function(e) {
        // The arrow is the toggle, not the whole <li>: the <li> also holds the
        // category link, so a handler on the row fought navigation and could not
        // tell "open me" from "follow this link".
        e.preventDefault();
        e.stopPropagation();
        var item = $(this).closest(".list-sidbar");
        var wasOpen = item.hasClass("active");
        // Close the others so only one stays open, then reopen this one unless it
        // was already open — that second tap is what closes it. The previous code
        // only ever ADDED "active" to the clicked row, so tapping the same row
        // again re-added the class and the dropdown never shut.
        item.siblings().removeClass("active");
        item.toggleClass("active", !wasOpen);
    }), $(".list-sidbar2 > .arrrow-icon").on("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).closest(".list-sidbar2").children(".inner-ul-sidebarr").toggleClass("active");
    });
  
    var didScroll, lastScrollTop = 0,
        delta = 5,
        navbarHeight = $(".header-fix").outerHeight();
    $(window).scroll(function(event) {
        didScroll = !0
    }), setInterval(function() {
        didScroll && (hasScrolled(), didScroll = !1)
    }, 250);

    function hasScrolled() {
        var st = $(this).scrollTop();
        Math.abs(lastScrollTop - st) <= delta || (st > lastScrollTop && st > navbarHeight ? $(".header-fix").removeClass("header-down").addClass("header-up") : st + $(window).height() < $(document).height() && $(".header-fix").removeClass("header-up").addClass("header-down"), lastScrollTop = st)
    }
    jQuery(window).width() <= 767 && $(".toggle-footer-heading").on("click", function() {
        $(this).hasClass("active") ? ($(this).removeClass("active"), $(this).siblings(".footer-link-list").slideUp(300)) : ($(".toggle-footer-heading").removeClass("active"), $(this).addClass("active"), $(".footer-link-list").slideUp(300), $(this).siblings(".footer-link-list").slideDown(300))
    }), window.addEventListener("load", function() {
        setTimeout(function() {}, 100)
    }), $(".widget_container").slick({
        dots: !1,
        infinite: !1,
        speed: 300,
        slidesToShow: 5,
        responsive: [{
            breakpoint: 1025,
            settings: {
                slidesToShow: 5,
                infinite: !1
            }
        }, {
            breakpoint: 991,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                dots: !0,
                arrows: !1,
                slidesToScroll: 1
            }
        }]
    }), $(".whislist-toggle").on("click", function() {
        $(this).toggleClass("active")
    }), $(".mobile-category-slide").slick({
        dots: !1,
        infinite: !1,
        speed: 300,
        arrows: !1,
        slidesToShow: 4.3
    }), $(".blog-related-profuct").slick({
        dots: !1,
        infinite: !0,
        arrows: !0,
        slidesToShow: 3,
        responsive: [{
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                arrows: !0,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 425,
            settings: {
                slidesToShow: 1,
                arrows: !0,
                slidesToScroll: 1
            }
        }]
    }), $(".explorer-slider").slick({
        dots: !0,
        infinite: !1,
        arrows: !1,
        speed: 300,
        slidesToShow: 2.8,
        responsive: [{
            breakpoint: 1025,
            settings: {
                slidesToShow: 2.5,
                infinite: !1
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 1.3
            }
        }]
    }), $(".slider-icon-list").slick({
        dots: !1,
        infinite: !1,
        arrows: !1,
        speed: 300,
        slidesToShow: 5,
        responsive: [{
            breakpoint: 1025,
            settings: {
                slidesToShow: 5,
                infinite: !1
            }
        }, {
            breakpoint: 767,
            settings: {
                dots: !0,
                slidesToShow: 3.5
            }
        }]
    }), $(".ingredients-slider").slick({
        dots: !1,
        infinite: !1,
        arrows: !0,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 2,
        responsive: [{
            breakpoint: 1025,
            settings: {
                slidesToShow: 3,
                infinite: !1,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 991,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 767,
            settings: {
                dots: !0,
                arrows: !1,
                slidesToShow: 1
            }
        }]
    }), $(".customer-slider").slick({
        centerMode: !0,
        centerPadding: "310px",
        arrows: !1,
        dots: !0,
        adaptiveHeight: !1,
        slidesToShow: 2,
        responsive: [{
            breakpoint: 1025,
            settings: {
                centerPadding: "210px",
                slidesToShow: 2
            }
        }, {
            breakpoint: 991,
            settings: {
                centerPadding: "110px"
            }
        }, {
            breakpoint: 767,
            settings: {
                centerMode: !1,
                infinite: !1,
                slidesToShow: 1.3
            }
        }]
    }), $(".blog-slider").slick({
        dots: !0,
        infinite: !1,
        arrows: !1,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 2,
        responsive: [{
            breakpoint: 1025,
            settings: {
                slidesToShow: 3,
                infinite: !1,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 991,
            settings: {
                slidesToShow: 3
            }
        }, {
            breakpoint: 767,
            settings: {
                dots: !0,
                arrows: !1,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: !1
            }
        }]
    }), $(".customer-say-slide").slick({
        dots: !0,
        infinite: !1,
        arrows: !1,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 1025,
            settings: {
                slidesToShow: 3,
                infinite: !1,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 991,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 767,
            settings: {
                dots: !0,
                arrows: !1,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: !1
            }
        }]
    }), $(".list-image-slider").slick({
        dots: !1,
        infinite: !1,
        arrows: !1,
        speed: 300,
        slidesToShow: 7,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 1025,
            settings: {
                slidesToShow: 6,
                infinite: !1,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 991,
            settings: {
                slidesToShow: 6
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: !1
            }
        }]
    }), $(".new-launch-slide").slick({
        dots: !1,
        infinite: !1,
        arrows: !1,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [{
            breakpoint: 1025,
            settings: {
                slidesToShow: 3,
                infinite: !1,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 991,
            settings: {
                slidesToShow: 3
            }
        }, {
            breakpoint: 767,
            settings: {
                dots: !0,
                arrows: !1,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: !1
            }
        }]
    }), $(".founder-slider-wraper").slick({
        infinite: !0,
        arrows: !1,
        slidesToShow: 1,
        adaptiveHeight: !0,
        dots: !0,
        slidesToScroll: 1
    }), $(".result-found-slide").slick({
        dots: !1,
        infinite: !1,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 1025,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: !1
            }
        }, {
            breakpoint: 991,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                dots: !0,
                arrows: !1,
                slidesToScroll: 2
            }
        }]
    })
}), $(".accor-faq > .heading-acc").on("click", function() {
    $(this).hasClass("active") ? ($(this).removeClass("active"), $(this).siblings(".content-faq").slideUp(200)) : ($(".accor-faq > .heading-acc").removeClass("active"), $(this).addClass("active"), $(".content-faq").slideUp(200), $(this).siblings(".content-faq").slideDown(200))
}), $(".select-dropdown__button").on("click", function() {
    $(".dropdowen-wraper").toggleClass("active"), $(".layer-bg-filter").addClass("show"), $("body").addClass("hidden-s")
}), $(".select-dropdown__list-item").on("click", function() {
    var itemValue = $(this).data("value");
    console.log(itemValue), $(".select-dropdown__button span").text($(this).text()).parent().attr("data-value", itemValue), $(".select-dropdown__list").toggleClass("active"), $(".layer-bg-filter").removeClass("show"), $(".dropdowen-wraper").removeClass("active"), $("body").removeClass("hidden-s")
}), $(".layer-bg-filter").click(function() {
    $(".layer-bg-filter").removeClass("show"), $(".dropdowen-wraper").removeClass("active"), $("body").removeClass("hidden-s")
}), $(".close-filter").click(function() {
    $(".layer-bg-filter").removeClass("show"), $(".dropdowen-wraper").removeClass("active"), $(".filter-by-wraper").removeClass("show"), $(".layer-bg-filter-by").removeClass("show"), $("body").removeClass("hidden-s")
}), $(".filter-m").click(function() {
    $(".filter-by-wraper").addClass("show"), $(".layer-bg-filter-by").addClass("show"), $("body").addClass("hidden-s")
}), $(".layer-bg-filter-by").click(function() {
    $(".filter-by-wraper").removeClass("show"), $(".layer-bg-filter-by").removeClass("show"), $("body").removeClass("hidden-s")
}), $(".type-select-filter").on("click", function() {
    $(this).parent(".list-filter-p").toggleClass("active-list").siblings().removeClass("active-list")
}), 
$(".m-deafult-product-gallery").on("beforeChange", function(event, slick, currentSlide) {
    // Stop the outgoing slide's video so audio does not continue over the next image.
    var $leaving = $(slick.$slides.get(currentSlide));
    $leaving.find("video").each(function() {
        if (!this.paused && typeof this.pause === "function") this.pause();
    });
    $leaving.find("iframe").each(function() {
        var src = this.src || "";
        if (!this.contentWindow) return;
        try {
            if (src.indexOf("youtube") !== -1) {
                this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
            } else if (src.indexOf("vimeo") !== -1) {
                this.contentWindow.postMessage('{"method":"pause"}', "*");
            }
        } catch (e) {}
    });
}).on("afterChange", function(event, slick, currentSlide) {
    // Autoplay is scoped to the visible slide, muted so the browser permits it.
    $(slick.$slides.get(currentSlide)).find("video").each(function() {
        if (!this.paused) return;
        if (!this.dataset.userUnmuted) this.muted = !0;
        var attempt = this.play();
        if (attempt && typeof attempt.catch === "function") attempt.catch(function() {});
    });
}).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: !0,
        dots: !1,
        fade: !0,
        responsive: [{
            breakpoint: 767,
            settings: {
                dots: !1
            }
        }]
      });

// The autoplay attribute would start every gallery video at once, including the
// off-screen ones. Hold all but the first until its slide is actually shown.
$(".m-deafult-product-gallery video").each(function() {
    var video = this;
    // Slick wraps slides in its own track, so compare against the currently
    // active slide rather than DOM position.
    if (!$(video).closest(".slick-slide").hasClass("slick-current")) {
        video.autoplay = !1;
        video.pause();
    }
    // Respect a shopper who turns sound on: never silently re-mute them.
    video.addEventListener("volumechange", function() {
        if (video.muted) delete video.dataset.userUnmuted;
        else video.dataset.userUnmuted = "true";
    });
});
 $(".m-deafult-product-nav").slick({
    arrows: !1,
    slidesToShow: 5,
    dots: !1,
    slidesToScroll: 1,
    infinite: !1,
    asNavFor: ".m-deafult-product-gallery",
    focusOnSelect: !0,
    verticalSwiping: !0,
    vertical: !0,
    responsive: [{
        breakpoint: 767,
        settings: {
            arrows: !0,
            slidesToShow: 5,
            vertical: !1
        }
    }]
});
$(".m-deafult-product-nav .slick-slide").on("click", function(event) {
    $(".m-deafult-product-gallery").slick("slickGoTo", $(this).data("slickIndex"))
});


$(".add").click(function() {
    $(this).prev().val(+$(this).prev().val() + 1)
}), $(".sub").click(function() {
    $(this).next().val() > 1 && $(this).next().val() > 1 && $(this).next().val(+$(this).next().val() - 1)
}), $(".slide-pdp-icon").slick({
    dots: !1,
    infinite: !1,
    arrows: !0,
    speed: 300,
    slidesToShow: 5,
    responsive: [{
        breakpoint: 1025,
        settings: {
            slidesToShow: 5,
            infinite: !1
        }
    }, {
        breakpoint: 991,
        settings: {
            slidesToShow: 3.5,
            infinite: !1
        }
    }, {
        breakpoint: 767,
        settings: "unslick"
    }]
}), $(".tab-menu li a").on("click", function() {
    var target = $(this).attr("data-rel");
    return $(".tab-menu li a").removeClass("active"), $(this).addClass("active"), $("#" + target).fadeIn("slow").siblings(".tab-box").hide(), !1
}), $(".pdp-slide-product").slick({
    dots: !1,
    infinite: !1,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [{
        breakpoint: 1025,
        settings: {
            slidesToShow: 2.5,
            slidesToScroll: 1,
            infinite: !1
        }
    }, {
        breakpoint: 991,
        settings: {
            slidesToShow: 2.5,
            slidesToScroll: 1
        }
    }, {
        breakpoint: 767,
        settings: {
            slidesToShow: 1.5,
            dots: !0,
            arrows: !1,
            slidesToScroll: 1
        }
    }]
}), $(document).ready(function() {
    $(".js-open-popup").click(function() {
        $(".popup-log-list").show(), $(".overlay-popup-list").show(), $(".forget-password-bx").hide()
    }), $(".custom-popup__close").click(function() {
        $(".popup-log-list").hide(), $(".overlay-popup-list").hide(), $(".sign-up-body").removeClass("sign-up-show"), $(".log-in-body").removeClass("sign-in-hide"), $(".forget-password-bx").hide()
    }), $(".overlay-popup-list").click(function() {
        $(".popup-log-list").hide(), $(this).hide(), $(".sign-up-body").removeClass("sign-up-show"), $(".log-in-body").removeClass("sign-in-hide")
    }), $(".sign-up-wraper-show").click(function() {
        $(".sign-up-body").addClass("sign-up-show"), $(".log-in-body").addClass("sign-in-hide")
    }), $(".log-in-show").click(function() {
        $(".sign-up-body").removeClass("sign-up-show"), $(".log-in-body").removeClass("sign-in-hide")
    }), $(".forget-pass-show").click(function() {
        $(".forget-password-bx").show(), $(".log-in-body").addClass("sign-in-hide")
    }), $(".form-froget").click(function() {
        $(".forget-password-bx").hide()
    }), $(".slider-video-home").slick({
        infinite: !1,
        arrows: !0,
        autoplay: !1,
        slidesToShow: 1,
        adaptiveHeight: !1,
        dots: !1,
        asNavFor: ".home-slider-nav",
        slidesToScroll: 1
    }), $(".home-slider-nav").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: !1,
        infinte: !1,
        asNavFor: ".slider-video-home",
        dots: !1,
        focusOnSelect: !0
    }), $(".edit-btn").click(function() {
        $(".edit-p-detail-popup").addClass("show"), $(".profile-detail").addClass("hide")
    }), $(".close-edit").click(function() {
        $(".edit-p-detail-popup").removeClass("show"), $(".profile-detail").removeClass("hide")
    }), $(".other-checkbx").click(function() {
        $(".bx-saved-add").addClass("show")
    }), $(".check-r").click(function() {
        $(".bx-saved-add").removeClass("show")
    }), $(".add-new-add").click(function() {
        $(".add-addresh-wraper").addClass("show"), $(".add-address-box-btn").addClass("hide")
    }), $(".cancel-button").click(function() {
        // $(".add-addresh-wraper").removeClass("show"), $(".add-address-box-btn").removeClass("hide")
        $(".add-addresh-wraper").removeClass("show"), $(".add-address-box-btn").removeClass("hide"), $(".add-addresh-wraper form[action='/account/addresses']").css("display","block");
    }), $(".view-details").click(function() {
        $(this).parent().parent().parent().siblings().addClass("show"), $(this).parent().parent().parent().addClass("hide")
    }), $(".order-clos-btn").click(function() {
        $(this).parent().removeClass("show"), $(this).parent().parent(".orders-inner-wraper").children(".order-box").removeClass("hide")
    }), $(".sara-fav-slide").slick({
        dots: !1,
        arrows: !0,
        infinite: !1,
        speed: 300,
        slidesToShow: 3,
        responsive: [{
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    }), $(".more-video-slide").slick({
        dots: !1,
        arrows: !0,
        infinite: !1,
        speed: 300,
        slidesToShow: 3,
        responsive: [{
            breakpoint: 991,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    }), $(".close-strip").click(function() {
        $(".offer-bottom-strip").css("display", "none"), setCookie("sale_closed", 1, 1)
    })
});

function onlyNumberKey(evt) {
    var ASCIICode = evt.which ? evt.which : evt.keyCode;
    return !(ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57))
}
$(document).ready(function() {
    var onlyNum = $(".onlytext");
    onlyNum.on("input", function(e) {
        var newValue = this.value.replace(new RegExp(/[^ A-Za-z0-9]/, "ig"), "");
        this.value = newValue
    })
}), $(".contry-selcetor .india").val("https://www.biotique.com" + window.location.pathname), $(".contry-selcetor .global").val("https://global.biotique.com" + window.location.pathname), document.addEventListener("DOMContentLoaded", () => {
    const imgContainer = document.getElementById("product-img-holder"),
        readMoreBtn = document.getElementById("readMore");
    try {
        readMoreBtn.addEventListener("click", () => {
            imgContainer.classList.toggle("show"), readMoreBtn.classList.add("read-more"), readMoreBtn.innerText === "Read Less" ? readMoreBtn.innerText = "Read More" : readMoreBtn.innerText = "Read Less"
        })
    } catch {}
});
//# sourceMappingURL=/s/files/1/0652/3787/6974/t/21/assets/custom.js.map?v=1715319016

// Disabled search for input
  document.addEventListener("DOMContentLoaded", function () {
    const searchInput = document.getElementById("Search");
    const searchBtn = document.getElementById("searchBtn");

    // Disable/enable button based on input value
    searchInput.addEventListener("input", function () {
      if (searchInput.value.trim() === "") {
        searchBtn.disabled = true;
      } else {
        searchBtn.disabled = false;
      }
    });
  });

